module.exports = function accumulateFlex (flex, grade) {
  return flex + grade.flex;
};
